import React, { useState, useEffect, useRef } from "react";
import bannerImg from "../assets/images/House5.jpg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowRight,
  faArrowRightLong,
  faAward,
  faBath,
  faBed,
  faEnvelope,
  faLocationDot,
  faMagnifyingGlass,
  faPhone,
  faStar,
} from "@fortawesome/free-solid-svg-icons";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay, EffectFade, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/effect-fade";
import avatar1 from "../assets/images/avatar1.png";
import avatar2 from "../assets/images/avatar3.png";
import placeholder from "../assets/images/house-placeholder.webp";
import { Link } from "react-router-dom";
import imgs from "./temp.json";
import ReactImageGallery from "react-image-gallery";
import calc from "../assets/images/shutterstock_2489188913-min.jpg";
import report from "../assets/images/shutterstock_699442570-min.jpg";
import house from "../assets/images/shutterstock_2493365641-min.jpg";
import constants from "../constants/constants";
import video from "../assets/images/2110972-uhd_3840_2160_30fps.mp4";
// import video from '../assets/images/1107548377-preview.mp4'
import formattingFunctions from "../functions/formatting";
import houseInterior from "../assets/images/shutterstock_2304013113-min.jpg";
import houseInterior2 from "../assets/images/shutterstock_1935730303-min.jpg";
import SEO from "./seo.component";
import pageSEO from "../constants/pageSEO";
import Contact from "./contact.component";
import isReactSnap from "../utils/isReactSnap";

export default function Homepage() {
  const proxyUrl = "https://cors-anywhere.herokuapp.com/";
  const testimonials = [
    {
      quote:
        "He is really good sds sf sdf sfsdf sdfsf sdfsdf sf sdfs dfs fsd fsfd fsd fsdf sdfsfds sdfs fsf sdfs dfsfdsdf sdfdsfs fsdffsd sdfsdfsf sdfsdf sdfsfsdfsdf sdfsdf sdfsdfsdf sdfsdfsdf",
      name: "Larry Ross",
      image: avatar1,
    },
    { quote: "Best realtor ever", name: "Sylvia Jones", image: avatar2 },
  ];
  const contact = useRef();
  const temp = [
    { CityRegion: "Beaches", Bedrooms: 4, Bathrooms: 3, ListPrice: 999000 },
    { CityRegion: "Leslieville", Bedrooms: 4, Bathrooms: 3, ListPrice: 999000 },
    { CityRegion: "Danforth", Bedrooms: 4, Bathrooms: 3, ListPrice: 999000 },
    { CityRegion: "High Park", Bedrooms: 4, Bathrooms: 3, ListPrice: 999000 },
  ];

  const [listings, setListings] = useState([]);
  const [media, setMedia] = useState(imgs.thumbs.value);
  const [formatted, setFormatted] = useState({});
  const loaded = useRef(false);
  const [windowSize, setWindowSize] = useState(window.innerWidth);
  const loadedRef = useRef(false);

  const onWindowResize = () => {
    setWindowSize(window.innerWidth);
  };
  useEffect(() => {
    window.addEventListener("resize", onWindowResize);
    return () => {
      window.removeEventListener("resize", onWindowResize);
    };
  }, []);

  function getData() {
    // Skip API calls during static generation
    if (isReactSnap()) {
      return Promise.resolve({ value: [] });
    }

    const upstreamUrl = `https://query.ampre.ca/odata/Property?$filter=(ListAgentKey eq '${constants.AGENT_ID}' and StandardStatus eq 'Active')&$orderby=OriginalEntryTimestamp desc,ListingKey&$top=12`;
    const body = {
      url: upstreamUrl,
      needAuth: true,
      bearerToken: constants.TOKEN,
    };

    return new Promise(async (resolve, reject) => {
      try {
        const isProd = constants.ENVIRONMENT === "production";
        if (isProd) {
          // In prod the Property endpoint supports direct fetch; keep it consistent with listings page
          const directUrl = `https://${constants.DOMAIN}/api/odata/Property?$filter=(ListAgentKey eq '${constants.AGENT_ID}' and StandardStatus eq 'Active')&$orderby=OriginalEntryTimestamp desc,ListingKey&$top=12`;
          const resp = await fetch(directUrl);
          if (!resp.ok) throw new Error("Failed to fetch property data");
          const res = await resp.json();
          resolve(res);
          return;
        }

        // Dev uses proxy metaGet
        const data = await fetch(`http://${constants.URL}/metaGet`, {
          method: "POST",
          body: JSON.stringify(body),
          headers: { "Content-Type": "application/json" },
        });
        if (data.ok) {
          const res = await data.json();
          resolve(res);
        } else {
          reject("Failed to fetch data");
        }
      } catch (err) {
        reject(err);
      }
    });
  }

  function getMedia(listings) {
    // Skip API calls during static generation
    if (isReactSnap() || !listings || listings.length === 0) {
      return Promise.resolve({ value: [] });
    }
    // Build upstream Media query against query.ampre.ca and proxy via metaGet (prod & dev)
    let upstream = `https://query.ampre.ca/odata/Media?$filter=ResourceRecordKey in (`;
    for (let l of listings) {
      upstream += `'${l.ListingKey}',`;
    }
    upstream = upstream.slice(0, -1);
    upstream += ") and ImageSizeDescription eq 'Medium' and PreferredPhotoYN eq true";

    const body = {
      url: upstream,
      needAuth: true,
      bearerToken: constants.TOKEN,
    };

    return new Promise(async (resolve, reject) => {
      try {
        const isProd = constants.ENVIRONMENT === "production";
        const metaUrl = isProd
          ? `${constants.URL_PROD}/metaGet`
          : `http://${constants.URL}/metaGet`;

        const resp = await fetch(metaUrl, {
          method: "POST",
          body: JSON.stringify(body),
          headers: { "Content-Type": "application/json" },
        });
        if (resp.ok) {
          const res = await resp.json();
          resolve(res);
        } else {
          reject("Failed to fetch data");
        }
      } catch (err) {
        reject(err);
      }
    });
  }

  function formatMedia(media) {
    var temp = {};

    for (let img of media) {
      if (temp[img.ResourceRecordKey]) {
        temp[img.ResourceRecordKey] = [...temp[img.ResourceRecordKey], img];
      } else {
        temp[img.ResourceRecordKey] = [img];
      }
    }
    return temp;
  }

  useEffect(() => {
    if (!loadedRef.current) {
      loadedRef.current = true;
      var temp1 = [];
      getData()
        .then((data) => {
          setListings(data.value);
          getMedia(data.value)
            .then((d) => {
              setMedia(d.value);
              temp1 = d.value;
              setFormatted(formatMedia(d.value));
            })
            .catch((err) => {
              console.log(err);
            });
        })
        .catch((err) => {
          console.log(err);
        });

      loaded.current = true;
    }
  }, []);

  function slugify(str) {
    str = str.replace(/^\s+|\s+$/g, "");
    str = str.toLowerCase();
    str = str
      .replace(/[^a-z0-9 -]/g, "")
      .replace(/\s+/g, "-")
      .replace(/-+/g, "-");
    return str;
  }

  const [keyword, setKeyword] = useState("");

  const seoConfig = pageSEO.home();

  return (
    <>
      <SEO {...seoConfig} />
      <div className="w-full  h-[100vh] relative flex ">
        {/* <div className="p-12 bg-logo-main w-min absolute top-[30%] left-[10%]">
                    <h1 className="text-white text-3xl sm:text-5xl font-mont">NICK </h1>
                    <h1 className="text-white text-3xl sm:text-5xl font-mont">LASTNAME</h1>
                    <h4 className="text-white text-xl font-mont mt-5 whitespace-normal">Real Estate Agent, TREB</h4>

                </div> */}
        <div className=" w-[100%] h-full min-[1100px]:w-[50%] flex flex-col absolute min-[1100px]:relative">
          <h1 className="text-5xl font-mont text-center pb-12 font-semibold min-[650px]:mt-[35%] mt-[25vh] px-10 text-white min-[1100px]:text-black">
            Find Your Dream Home
          </h1>
          <div className="flex gap-6 self-center">
            {/* <div className="relative flex-1 ">
              <input
                className="form-input"
                placeholder="Search Keyword"
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                style={{ borderRadius: "99999px" }}
              ></input>
              <FontAwesomeIcon
                icon={faMagnifyingGlass}
                className="absolute right-4 top-2 text-med-grey"
              />
            </div> */}
            <Link to={"/listings"} state={keyword}>
              <button className="btn-rounded">Search</button>
            </Link>
          </div>
          <div className="flex flex-col min-[500px]:flex-row gap-4 items-start min-[1000px]:w-[90%] w-[85vw] justify-between mx-10 absolute bottom-10">
            <div
              onClick={() => contact.current.scrollIntoView()}
              className="cursor-pointer hover:bg-logo-main rounded-full bg-black px-3 py-2 min-[500px]:self-center"
            >
              <span className="text-white">
                <FontAwesomeIcon
                  icon={faPhone}
                  className="mr-2 whitespace-nowrap"
                />
                Contact {constants.AGENT_NAME?.split(" ")[0]} Now
              </span>
            </div>

            <Link to={"/listings"}>
              <div className="flex flex-wrap gap-x-1 text-white min-[1100px]:text-black items-center ">
                <span className="font-semibold ">See All Listings</span>
                <FontAwesomeIcon
                  className="pr-1"
                  transform={{ rotate: -45 }}
                  icon={faArrowRightLong}
                />
                <div className="h-12 w-12 overflow-hidden rounded-full">
                  <img
                    className="h-full w-full object-cover"
                    src={constants.HOME_IMAGE}
                  ></img>
                </div>
              </div>
            </Link>
          </div>
        </div>
        
        <div
          className="w-[100%] min-[1100px]:w-[50%] rounded-2xl m-5 bg-cover"
          style={{
            backgroundImage: `url(${constants.HOME_IMAGE})`,
            backgroundPosition: "center",
          }}
        ></div>
      </div>
      <div className=" pb-24 bg-slate-800 w-full">
        {/* <h1 className="text-4xl text-white py-10 font-mont px-10 uppercase pt-14 max-w-[1700px] mx-auto">Featured Neighbourhoods</h1>

                <div className="grid min-[750px]:grid-cols-2 px-10 max-w-[1700px] mx-auto">
                    {constants.LOCATIONS.slice(0, 4).map((location) =>
                    <Link to={`location/${formattingFunctions.slugify(location.name)}`}>
                        <div className="h-[40vh] relative cursor-pointer overflow-hidden flex items-center justify-center">
                            <img className="absolute h-full  object-cover opacity-75 hover:opacity-50 w-full top-[50%] translate-y-[-50%] hover:scale-105 duration-500 " src={location.img} />
                            <h1 className="text-3xl  text-white py-8 font-mont px-10 uppercase z-10">{location.name}</h1>

                        </div>
                        </Link>
                    )}


                </div> */}
        <div
          className="px-10  min-[900px]:grid py-32"
          style={{ gridTemplateColumns: "40% 60%" }}
        >
          <div className="flex items-center flex-col gap-y-4">
            <h1 className="text-4xl  text-white pb-8  px-10 font-mont uppercase z-10 text-center">
              About Me
            </h1>
            <div className="rounded-full w-52  lg:w-64  overflow-clip z-30 mx-4 mb-12">
              <img
                src={constants.HEADSHOT}
                className="h-full w-full object-cover"
              />
            </div>
          </div>
          <div className="flex flex-col text-white font-mont text-xl min-[900px]:pr-[30%]">
            {constants.ABOUT ? (
              constants.ABOUT.split("<|>").map((p) => (
                <p key={p}>
                  {p}
                  <br />
                  <br />
                </p>
              ))
            ) : (
              <p>Coming Soon</p>
            )}
            <div className="flex gap-x-4">
              <button
                onClick={() => contact.current.scrollIntoView()}
                className="btn-primary self-start mt-5 "
              >
                CONTACT ME
              </button>
              <Link className="btn-tertiary self-start mt-5" to={"/about"}>
                <button>FULL BIO</button>
              </Link>
            </div>
          </div>
        </div>
      </div>
      {/* <div className=" pb-24 bg-slate-800">

                <div className="flex justify-between items-center mx-auto max-w-[1500px] px-7 ">

                    <h1 className="text-4xl text-white py-8 font-mont ">OUR AGENTS</h1>
                    <Link className="underline font-semibold underline-offset-4 text-white" to={"/agents"}>View All</Link>
                </div>
                <div className='mx-auto max-w-[1500px] px-7 h-[40vh] sm:h-[30vh] md:h-[45vh]' >

                    <Swiper
                        style={{ "--swiper-pagination-color": "white", "--swiper-button-prev": 'white', '--swiper-pagination-bullet-inactive-color': '#f1f1f1', '--swiper-theme-color': 'lightgrey' }}
                        slidesPerView={1}
                        spaceBetween={50}
                        pagination={{
                            clickable: true,
                        }}
                        navigation={true}
                        loop={true}
                        loopPreventsSliding={true}

                        autoplay={{
                            delay: 7500,
                            disableOnInteraction: true,
                            pauseOnMouseEnter: true
                        }}
                        modules={[Pagination, Autoplay, Navigation]}
                        breakpoints={{

                            640: {
                                spaceBetween: 30,
                                slidesPerView: 2
                            },
                            950: {
                                spaceBetween: 50,
                                slidesPerView: 3
                            },

                        }}


                    >

                        {
                            constants.AGENTS?.map((agent, index) =>
                                <SwiperSlide key={index} >

                                    <div className=' h-[40vh] sm:h-[30vh] md:h-[45vh]' >
                                        <Link className="w-full " state={agent} to={`agents/${slugify(agent.name)}`}>
                                            <div className="relative w-full aspect-[5/3] sm:aspect-[4/3] overflow-hidden group">
                                                <img className="w-full h-full object-cover" src={agent.img ?? placeholder} />
                                                <div className="px-4 py-2 duration-1000 h-[100px] bg-logo-second bg-opacity-50 absolute bottom-0 w-full text-white group-hover:h-full">
                                                    <p className="text-xl font-mont font-semibold">{agent.name}</p>
                                                    <p className=" italic">{agent.title}</p>
                                                    <div className="flex gap-x-4 mt-2">
                                                        {Object.entries(agent.socials ?? {})?.map(([k, v], index) =>
                                                            <a href={v}>
                                                                <FontAwesomeIcon className="fa-lg" icon={constants.ICONS[k]} />

                                                            </a>
                                                        )}
                                                    </div>
                                                    <p className="mt-7 text-xl font-semibold">About {agent.name?.split(' ')[0]}</p>
                                                    <p className="mt-3">{agent.bio ? agent.bio.replace(/(<([^>]+)>)/gi, '')?.split(' ')?.splice(0, windowSize > 950 && windowSize < 1500 ? 20 : 50)?.join(' ') + " ..." : 'Coming Soon'}</p>
                                                </div>
                                            </div>

                                        </Link>
                                    </div>
                                </SwiperSlide>


                            )
                        }

                    </Swiper>
                </div>
                <div className="grid mx-auto mt-12 sm:grid-cols-3 w-fit gap-x-12 gap-y-12 child:max-w-64 child:flex child:flex-col child:gap-y-5 child:text-center ">
                    <div>
                        <FontAwesomeIcon icon={faAward} className="fa-5x text-med-grey " />
                        <span className="text-med-grey font-semibold text-2xl">2022</span>
                        <span className="text-white font-semibold text-xl">Best Realtor Toronto</span>
                    </div>
                    <div>
                        <FontAwesomeIcon icon={faStar} className="fa-5x text-med-grey" />
                        <span className="text-med-grey font-semibold text-2xl">2023</span>
                        <span className="text-white font-semibold text-xl">Most Houses Sold</span>
                    </div>
                    <div>
                        <FontAwesomeIcon icon={faAward} className="fa-5x text-med-grey" />
                        <span className="text-med-grey font-semibold text-2xl">2019</span>
                        <span className="text-white font-semibold text-xl">Favourite Realtor </span>
                    </div>





                </div>
              
            </div> */}
            {/* Testimonials Section */}
        <div className="w-full bg-logo-main py-20">
          <div className="max-w-[1900px] mx-auto px-10">
            <h1
              className={`text-4xl text-center libre mb-12 ease-in-out duration-2000 slide-in ${
                windowSize > 700 ? "slide-left" : ""
              }`}
            >
              What Our Clients Say
            </h1>
            
            <div className="max-w-[1200px] mx-auto">
              <Swiper
                style={{ 
                  "--swiper-pagination-color": "#5e658a", 
                  "--swiper-navigation-color": "#5e658a",
                  "--swiper-pagination-bullet-inactive-color": "#cccccc"
                }}
                slidesPerView={1}
                spaceBetween={30}
                pagination={{
                  clickable: true,
                }}
                navigation={true}
                loop={true}
                autoplay={{
                  delay: 6000,
                  disableOnInteraction: false,
                  pauseOnMouseEnter: true
                }}
                modules={[Pagination, Autoplay, Navigation]}
                breakpoints={{
                  768: {
                    slidesPerView: 2,
                    spaceBetween: 40
                  },
                  1024: {
                    slidesPerView: 3,
                    spaceBetween: 50
                  }
                }}
                className="pb-12"
              >
                {constants.TESTIMONIALS?.map((testimonial, index) => (
                  <SwiperSlide key={index}>
                    <div className="bg-white rounded-lg shadow-lg p-6 h-full flex flex-col">
                      <div className="flex-1">
                        <div className="text-logo-third text-4xl mb-4">"</div>
                        <p className="text-gray-700 leading-relaxed mb-6 flex-1">
                          {testimonial.quote.length > 200 
                            ? testimonial.quote.substring(0, 200) + "..." 
                            : testimonial.quote}
                        </p>
                      </div>
                      <div className="mt-auto">
                        <div className="flex items-center">
                          <div className="w-12 h-12 bg-logo-third rounded-full flex items-center justify-center text-white font-bold text-xl mr-4">
                            {testimonial.name.charAt(0)}
                          </div>
                          <div>
                            <p className="font-semibold text-logo-second">
                              {testimonial.name}
                            </p>
                            <p className="text-sm text-gray-500">Satisfied Client</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </div>
        </div>
      <div className="bg-logo-main px-10">
        {/* <h1 className="text-4xl text-white py-10 pt-20 font-mont text-center uppercase">Unsure about the next step? Let us help</h1>

                <div className="py-10 grid grid-cols-2 gap-24 max-w-[1000px] mx-auto">
                    <div className="h-[40vh] relative cursor-pointer overflow-hidden flex items-center justify-center">
                        <img className="absolute h-full object-cover opacity-75 hover:opacity-50 w-full top-[50%] translate-y-[-50%] hover:scale-105 duration-500 " src={house} />
                        <h1 className="text-3xl  text-white py-8 font-mont px-14 text-center uppercase z-10">I am looking to buy</h1>

                    </div>
                    <div className="h-[40vh] relative cursor-pointer overflow-hidden flex items-center justify-center">
                        <img className="absolute h-full object-cover opacity-75 hover:opacity-50 w-full top-[50%] translate-y-[-50%] hover:scale-105 duration-500 " src={house} />
                        <h1 className="text-3xl  text-white py-8 font-mont px-14 text-center uppercase z-10">I am Looking to Sell</h1>

                    </div>


                </div> */}
        <div className="flex justify-between items-center pt-14 pb-10 max-w-[1700px] mx-auto">
          <h1 className="text-4xl text-white  font-mont uppercase ">
            Featured Listings
          </h1>
          <Link
            className="underline font-semibold underline-offset-4 whitespace-nowrap text-white"
            to={"/listings"}
          >
            View All
          </Link>
        </div>
        <div className="grid min-[900px]:grid-cols-2 min-[1000px]:gap-10 gap-6 pb-24 max-w-[1700px] mx-auto">
          {listings?.slice(0, 4)?.map((prop) => (
            <Link style={{maxWidth: "900px"}} key={prop.ListingKey} className="w-full h-full" to={`/listing/${prop.ListingKey}`}>
              <div className="relative w-full rounded-2xl aspect-[5/3] sm:aspect-[4/3] overflow-hidden group">
                {/* <img className="w-full h-full object-cover" src={formatted[prop.ListingKey]?.find((img) => img.Order === 0)?.MediaURL ?? formatted[prop.ListingKey]?.[0]?.MediaURL ?? placeholder} /> */}
                <img
                  className="w-full opacity-75 h-full object-cover group-hover:opacity-85 duration-1000 group-hover:scale-105"
                  src={
                    formatted[prop.ListingKey]?.find((img) => img.Order === 0)
                      ?.MediaURL ??
                    formatted[prop.ListingKey]?.[0]?.MediaURL ??
                    placeholder
                  }
                />
                <p className="font-bold text-white text-2xl absolute min-[1100px]:top-[85%] min-[1100px]:translate-y-[-85%] top-[70%] translate-y-[-70%] m-10 duration-1000 min-[1100px]:group-hover:top-6 group-hover:top-0">
                  <FontAwesomeIcon icon={faLocationDot} className="pr-3" />
                  {prop.CityRegion ?? prop.CrossStreet}
                </p>
                <div className="hidden whitespace-nowrap flex-wrap absolute bottom-0 p-8 group-hover:flex gap-4">
                  <div
                    style={{ backgroundColor: "rgb(250, 250, 250, .8)" }}
                    className=" rounded-xl py-2 px-3 font-semibold text-deep-grey text-lg"
                  >
                    <span>
                      <FontAwesomeIcon icon={faBed} className="pr-2" />
                      {prop.BedroomsTotal} Bed
                    </span>
                  </div>
                  <div
                    style={{ backgroundColor: "rgb(250, 250, 250, .8)" }}
                    className=" rounded-xl py-2 px-3 font-semibold text-deep-grey text-lg"
                  >
                    <span>
                      <FontAwesomeIcon icon={faBath} className="pr-2" />
                      {prop.BathroomsTotalInteger} Bath
                    </span>
                  </div>

                  <div
                    style={{ backgroundColor: "rgb(250, 250, 250, .8)" }}
                    className=" rounded-xl py-2 px-3 font-semibold text-deep-grey text-lg"
                  >
                    <span>${prop.ListPrice?.toLocaleString()} List Price</span>
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <h1 className="text-4xl text-white py-10 pt-18 font-mont text-center uppercase">
          Unsure about the next step? Let us help
        </h1>

        <div className="py-10 pb-32 grid min-[750px]:grid-cols-2 min-[1100px]:gap-24 gap-12 max-w-[1000px] mx-auto">
          <Link
            to={"/listings"}
            className="h-[40vh] relative cursor-pointer overflow-hidden flex items-center justify-center"
          >
            <img
              className="absolute h-full object-cover opacity-75 hover:opacity-50 w-full top-[50%] translate-y-[-50%] hover:scale-105 duration-500 "
              src={houseInterior}
            />
            <h1 className="text-3xl  text-white py-8 font-mont px-14 text-center uppercase z-10">
              I am looking to buy
            </h1>
          </Link>
          <Link
            to={"/evaluation"}
            className="h-[40vh] relative cursor-pointer overflow-hidden flex items-center justify-center"
          >
            <img
              className="absolute h-full object-cover opacity-75 hover:opacity-50 w-full top-[50%] translate-y-[-50%] hover:scale-105 duration-500 "
              src={houseInterior2}
            />
            <h1 className="text-3xl  text-white py-8 font-mont px-14 text-center uppercase z-10">
              I am Looking to Sell
            </h1>
          </Link>
        </div>
      </div>

      <div
        ref={contact}
      >
        <Contact />
      </div>
    </>
  );
}
